import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { lensProp, set, lensPath, isEmpty } from "ramda";
import { notBlank } from "../../util/ext";

import { MediaContext } from "./media-context";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    flexGrow: 1,
    flexBasis: "100%",
    padding: theme.spacing(3),
  },

  header: {
    textTransform: "uppercase",
    fontSize: "1rem",
    fontWeight: "bold",
    color: theme.palette.primary.darker,
    marginBottom: theme.spacing(2),
  },

  buttonArea: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },

  button: {
    backgroundColor: "#127DA9",
  },

  form: {
    marginTop: theme.spacing(3),
  },
}));

const EditColumn = props => {
  const classes = useStyles();
  const context = useContext(MediaContext);
  const { name, validator, formBuilder, className, isNew } = props;

  const handleBlur = (field, value) => {
    const errors = validator.validateField(field, value);
    context.setErrors(errors);
  };

  const handleTextChange = path => event => {
    const value = event.target.value;
    context.setMedia(prev => set(lensPath(path), value, prev));
  };

  const handleAutocompleteChange = (field, path) => (_event, option) => {
    const value = option[field];
    context.setMedia(prev => set(lensPath(path), value, prev));
  };

  const handleDateChange = field => value => {
    context.setMedia(prev => set(lensProp(field), value, prev));
  };

  const handleCheckboxChange = field => event => {
    const value = event.target.checked;
    context.setMedia(prev => set(lensProp(field), value, prev));
  };

  const handleMediaStatusChange = event => {
    // if value is "", set status as null
    const value = isEmpty(event.target.value) ? null : event.target.value;

    // if deleting, then free up internalCode for other content groups
    if (value === "DELETED") {
      context.setMedia(set(lensProp("internalCode"), null));
    }
    context.setMedia(set(lensProp("status"), value));
  };

  return (
    <div className={className || classes.root}>
      {notBlank(name) && <div className={classes.header}>{name}</div>}
      {(notBlank(context.media) || isNew) &&
        formBuilder({
          onTextChange: handleTextChange,
          onDateChange: handleDateChange,
          onCheckboxChange: handleCheckboxChange,
          onAutocompleteChange: handleAutocompleteChange,
          onMediaStatusChange: handleMediaStatusChange,
          onBlur: handleBlur,
        })}
    </div>
  );
};

export default EditColumn;
